var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { useSelector } from "react-redux";
// components
import { ClientDetails } from "./components";
import { ToastModal } from "../../components/common";
import GenericSidebar from "@frameworks/shared-library/components/GenericSidebar";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Aif&PmsSidebar.scss";
import Header from "../../components/Header";
// helpers
import { emailRegex } from "../../utils/regex";
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
import { getDateInFormat } from "@domains/utils/reportDates";
import { capitalizeWords } from "../../utils";
function AddClientDetails(_a) {
    //
    var visible = _a.visible, setVisible = _a.setVisible, onClickCancel = _a.onClickCancel, onClickVerify = _a.onClickVerify;
    var _b = useSelector(function (state) { return state.markets.AifPms; }), clientDetails = _b.clientDetails, watchListData = _b.watchListData;
    var _c = __read(useState("mobile"), 2), selectedOption = _c[0], setSelectedOption = _c[1];
    var _d = __read(useState(""), 2), mobileNo = _d[0], setMobileNo = _d[1];
    var _e = __read(useState(new Date()), 2), selectedDate = _e[0], setSelectedDate = _e[1];
    var _f = __read(useState(""), 2), email = _f[0], setEmail = _f[1];
    var _g = __read(useState(false), 2), isError = _g[0], setIsError = _g[1];
    var _h = __read(useState(), 2), error = _h[0], setError = _h[1];
    var _j = __read(useState(false), 2), emailError = _j[0], setEmailError = _j[1];
    var _k = __read(useState({
        visible: false,
        message: "",
    }), 2), toastDetails = _k[0], setToastDetails = _k[1];
    var isButtonDisabled = function () {
        if (selectedOption === "mobile" && mobileNo.length < 10) {
            return true;
        }
        if (selectedOption === "dob" && !selectedDate) {
            return true;
        }
        if (selectedOption === "email" && (!email || !emailRegex.test(email))) {
            return true;
        }
        return false;
    };
    var handleValidateClient = function () {
        var validationValue = selectedOption === "mobile"
            ? "91".concat(mobileNo)
            : selectedOption === "dob"
                ? getDateInFormat(selectedDate, "DD-MM-YYYY")
                : selectedOption === "email"
                    ? email
                    : null;
        if (validationValue === null) {
            throw new Error("Invalid validation type or value.");
        }
        aifPmsDi.global
            .validateClient({
            ucc_code: clientDetails.uniqueCode,
            validationtype: selectedOption,
            validationvalue: validationValue,
        })
            .then(function (response) {
            var _a, _b, _c;
            var data = response === null || response === void 0 ? void 0 : response.data;
            if ((data === null || data === void 0 ? void 0 : data.length) <= 0 && mobileNo.length > 0) {
                setIsError(true);
            }
            else {
                setEmail("");
                setMobileNo("");
                onClickVerify(response, watchListData === null || watchListData === void 0 ? void 0 : watchListData.schemeId);
                setToastDetails({
                    visible: true,
                    message: ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.length) > 0
                        ? "Client validated"
                        : "Client not validated",
                });
                setTimeout(function () {
                    setToastDetails({
                        visible: false,
                        message: "",
                    });
                }, 1000);
                aifPmsDi.aifPms.updateClientDetails(__assign(__assign({}, clientDetails), { clientName: capitalizeWords((_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.acname) }));
            }
        })
            .catch(function (error) { });
    };
    var onSideBarClose = function () {
        setEmailError(false);
        setIsError(false);
        setError({});
        setEmail("");
        setMobileNo("");
        setSelectedOption("mobile");
        onClickCancel();
    };
    return (React.createElement("div", { className: "position-relative" },
        React.createElement(GenericSidebar, { parentClassname: "primary-aif-pms-sidebar-container client-details-container d-flex flex-column", header: React.createElement(Header, { title: "Enter client details", subText: "Client matching this PAN needs additional details" }), body: React.createElement(React.Fragment, null,
                React.createElement(ClientDetails, { selectedOption: selectedOption, mobileNo: mobileNo, selectedDate: selectedDate, email: email, onSelectedOptionChange: setSelectedOption, onMobileNoChange: function (value, countryCode) {
                        setMobileNo(value);
                    }, onSelectedDateChange: setSelectedDate, onEmailChange: setEmail, isError: isError, setIsError: setIsError, error: error, setError: setError, emailError: emailError, setEmailError: setEmailError }),
                React.createElement(ToastModal, { visible: toastDetails.visible, setVisible: function (value) {
                        setToastDetails(function (prev) { return (__assign(__assign({}, prev), { visible: value })); });
                    }, message: toastDetails.message })), footer: React.createElement("div", { className: "d-flex justify-content-center flex-wrap" },
                React.createElement(EdButton, { onClick: onClickCancel, btnTyp: "link", value: "Cancel", className: "DMSans_16_500" }),
                React.createElement(EdButton, { onClick: handleValidateClient, btnTyp: "".concat(isButtonDisabled() ? "midnight-blue" : "tomato-red"), value: "Verify", className: "partner-proceed rounded-pill DMSans_16_500 width-180 px-0", disabled: isButtonDisabled() })), openKey: visible, setOpenKey: setVisible, arrowClose: true, delay: 10, blurBackground: true, parentIcon: "edel-icon-close", onSideBarClose: onSideBarClose })));
}
export default AddClientDetails;
